import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { withDevtools } from '@ngrx-toolkit/core';
import { getNextPingPongTime } from 'src/app/shared/utils/date.utils';
import {
  WsCurrentlySubscribedModel,
  WsSubscribeAs,
} from 'src/app/shared/models/ws.models';

interface WsState {
  nextPingPong: number;
  currentlySubscribed: WsCurrentlySubscribedModel | undefined;
}

export const WsStore = signalStore(
  withDevtools('ws'),
  withState<WsState>(() => ({
    nextPingPong: getNextPingPongTime(),
    currentlySubscribed: undefined,
  })),
  withMethods(store => ({
    pingPongUpdate(nextPingPong: number) {
      patchState(store, { nextPingPong });
    },
    subscribe(id: string, subscribedAs: WsSubscribeAs, nextPingPong: number) {
      patchState(store, {
        currentlySubscribed: { id, subscribedAs },
        nextPingPong,
      });
    },
    unsubscribe(nextPingPong: number) {
      patchState(store, { currentlySubscribed: undefined, nextPingPong });
    },
  })),
);
